const DATA_TEST_IDS = {
  companyDetailsAdSection: 'company-details__ad-section',
  companyDetailsBackButton: 'company-details__back-button',
  companyDetailsCompanyDetailsPage: 'company-details__company-details-page',
  companyDetailsDescriptionSection: 'company-details__description-section',
} as const;

export default DATA_TEST_IDS;
